import { AUTO, MAXINT } from '../constants.js';
import { defined } from '../utils/functions.js';

function mwDelta(e) {
    let delta = 0;
    if (e.wheelDelta) {
        delta = -e.wheelDelta / 40;
        delta = delta > 0 ? Math.ceil(delta) : Math.floor(delta);
    }
    else if (e.detail) {
        delta = e.detail;
    }
    return delta;
}
function isAutoConnector(connector) {
    return connector.options.name.toLowerCase() === AUTO.toLowerCase();
}
function closestConnector(point, connectors) {
    let minimumDistance = MAXINT, resCtr, connector;
    for (let i = 0; i < connectors.length; i++) {
        connector = connectors[i];
        if (!isAutoConnector(connector)) {
            const dist = point.distanceTo(connector.position());
            if (dist < minimumDistance) {
                minimumDistance = dist;
                resCtr = connector;
            }
        }
    }
    return resCtr;
}
function indicesOfItems(group, visuals) {
    const indices = [];
    let i, visual;
    const children = group.drawingContainer().children;
    const length = children.length;
    for (i = 0; i < visuals.length; i++) {
        visual = visuals[i];
        for (let j = 0; j < length; j++) {
            if (children[j] === visual.drawingContainer()) {
                indices.push(j);
                break;
            }
        }
    }
    return indices;
}
function translateToOrigin(visual) {
    const bbox = visual.drawingContainer().clippedBBox(null);
    if (bbox.origin.x !== 0 || bbox.origin.y !== 0) {
        visual.position(-bbox.origin.x, -bbox.origin.y);
    }
}
function filterShapeDataItem(dataItem) {
    const result = {};
    dataItem = dataItem || {};
    if (defined(dataItem.text) && dataItem.text !== null) {
        result.text = dataItem.text;
    }
    if (defined(dataItem.x) && dataItem.x !== null) {
        result.x = dataItem.x;
    }
    if (defined(dataItem.y) && dataItem.y !== null) {
        result.y = dataItem.y;
    }
    if (defined(dataItem.width) && dataItem.width !== null) {
        result.width = dataItem.width;
    }
    if (defined(dataItem.height) && dataItem.height !== null) {
        result.height = dataItem.height;
    }
    if (defined(dataItem.type) && dataItem.type !== null) {
        result.type = dataItem.type;
    }
    return result;
}
function filterConnectionDataItem(dataItem) {
    const result = {};
    dataItem = dataItem || {};
    if (defined(dataItem.text) && dataItem.text !== null) {
        result.content = dataItem.text;
    }
    if (defined(dataItem.type) && dataItem.type !== null) {
        result.type = dataItem.type;
    }
    if (defined(dataItem.from) && dataItem.from !== null) {
        result.from = dataItem.from;
    }
    if (defined(dataItem.fromConnector) && dataItem.fromConnector !== null) {
        result.fromConnector = dataItem.fromConnector;
    }
    if (defined(dataItem.fromX) && dataItem.fromX !== null) {
        result.fromX = dataItem.fromX;
    }
    if (defined(dataItem.fromY) && dataItem.fromY !== null) {
        result.fromY = dataItem.fromY;
    }
    if (defined(dataItem.to) && dataItem.to !== null) {
        result.to = dataItem.to;
    }
    if (defined(dataItem.toConnector) && dataItem.toConnector !== null) {
        result.toConnector = dataItem.toConnector;
    }
    if (defined(dataItem.toX) && dataItem.toX !== null) {
        result.toX = dataItem.toX;
    }
    if (defined(dataItem.toY) && dataItem.toY !== null) {
        result.toY = dataItem.toY;
    }
    return result;
}

export { closestConnector, filterConnectionDataItem, filterShapeDataItem, indicesOfItems, isAutoConnector, mwDelta, translateToOrigin };
